export default "__VITE_ASSET__CJIexw04__"